export default __webpack_public_path__ + "images/arrow_right-5f011f9aa5e1365f3afe67d56de01b5d.svg";